export default __webpack_public_path__ + "static/media/databases.2363d461.svg";